import { FaroInsightsWrapper } from "@/grafana-faro"
import { CopilotTag } from "@/modules/patients/components/copilot-tag"
import {
  SuggestedCondition,
  useHealthInformationCopilotContext,
} from "@/modules/patients/contexts/health-information-copilot-context"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { PatientConditionInformationOutputFragment$data } from "@/modules/patients/services/__generated__/PatientConditionInformationOutputFragment.graphql"
import { useDrawerStore } from "@/stores/useDrawerStore"

export const ConditionCopilots = ({
  onOpenConditionDrawer,
  currentConditions,
  patientId,
}: {
  onOpenConditionDrawer: () => void
  patientId: string
  currentConditions: PatientConditionInformationOutputFragment$data["conditions"]
}) => {
  const drawerName = useDrawerStore((state) => state.drawerName)
  const appointmentId = useAppointmentParam()
  const copilotConditions = useHealthInformationCopilotContext((v) => v.conditions.data)
  const hideCopilotCondition = useHealthInformationCopilotContext((v) => v.conditions.hide)
  const setSelectedCopilotCondition = useHealthInformationCopilotContext((v) => v.conditions.setSelected)

  const handleOpenConditionDrawer = (conditionCopilot: SuggestedCondition) => {
    if (drawerName !== "ConditionsDrawer") {
      onOpenConditionDrawer()
    }
    setSelectedCopilotCondition(conditionCopilot)
    hideCopilotCondition(conditionCopilot)
  }

  const filteredCopilotConditions = copilotConditions.filter(
    (copilot) => !currentConditions.some((condition) => condition.icdDiagnosis.diagnosisCode === copilot.diagnosisCode),
  )

  return (
    filteredCopilotConditions.length > 0 && (
      <div className="flex max-w-full flex-wrap items-center gap-2" data-testid="condition-copilot-tag-section">
        {filteredCopilotConditions.map((copilot) => (
          <CopilotTag
            key={copilot.diagnosisCode}
            id={copilot.diagnosisCode}
            name={copilot.text}
            onCancel={() => {
              hideCopilotCondition(copilot)
              FaroInsightsWrapper.pushEvent("health_information_copilot_condition_reject", {
                conditionId: copilot.diagnosisCode,
                appointmentId: appointmentId ?? "",
                patientId: patientId,
              })
            }}
            onApprove={() => {
              handleOpenConditionDrawer(copilot)
              FaroInsightsWrapper.pushEvent("health_information_copilot_condition_accept", {
                conditionId: copilot.diagnosisCode,
                appointmentId: appointmentId ?? "",
                patientId: patientId,
              })
            }}
          />
        ))}
      </div>
    )
  )
}
